import { render, staticRenderFns } from "./EditSense.vue?vue&type=template&id=00567218&scoped=true&"
import script from "./EditSense.vue?vue&type=script&lang=js&"
export * from "./EditSense.vue?vue&type=script&lang=js&"
import style0 from "./EditSense.vue?vue&type=style&index=0&id=00567218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00567218",
  null
  
)

export default component.exports